export default "__VITE_ASSET__4f34307c__"